import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import './styles.scss';

const IconToggle = ({icon, enabled, onClick}) => (
  <div onClick={onClick} className={classNames('icon-toggle', {'active': enabled})}>
    {icon}
  </div>
);

IconToggle.propTypes = {
  icon: PropTypes.element.isRequired,
  enabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default IconToggle;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/widgets/IconToggle/index.js